var React = require('react');

function TwitterLogoButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 7"},React.createElement("path",{"data-name":"Path 11","d":"M20.325,0A20.325,20.325,0,1,0,40.65,20.325,20.348,20.348,0,0,0,20.325,0Zm9.067,15.673c.009.2.014.4.014.607A13.307,13.307,0,0,1,8.924,27.489a9.446,9.446,0,0,0,6.926-1.937A4.683,4.683,0,0,1,11.48,22.3a4.7,4.7,0,0,0,2.112-.079A4.679,4.679,0,0,1,9.84,17.636c0-.02,0-.04,0-.059a4.659,4.659,0,0,0,2.118.585,4.685,4.685,0,0,1-1.447-6.246,13.283,13.283,0,0,0,9.642,4.889,4.681,4.681,0,0,1,7.972-4.268A9.338,9.338,0,0,0,31.1,11.4a4.7,4.7,0,0,1-2.06,2.589,9.3,9.3,0,0,0,2.687-.736A9.41,9.41,0,0,1,29.392,15.673Z","fill":"#00c0d6"})));
}

TwitterLogoButton.defaultProps = {"width":"40.65","height":"40.65","viewBox":"0 0 40.65 40.65"};

module.exports = TwitterLogoButton;

TwitterLogoButton.default = TwitterLogoButton;
